import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MainLayout } from '~/components/layout/MainLayout'

export const Route = createFileRoute('/legal')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}
